import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../Shared/Sidebar';
import Icon from '../Shared/Icons';
import { useAuth } from '../../context/AuthContext';
import { PROGRAMS } from '../../config/programs';
import { STAFF_WEEKLY_FIELDS, completionOf } from '../../utils/reportSchema';
import {
  fetchReports, fetchReportById, saveStaffWeekly, staffWeeklyId, resolveAuthorName,
} from '../../utils/programData';
import { isoWeekKey, weekLabel, shiftWeeks, daysLeftInWeek, fmtDateTime } from '../../utils/weekUtils';
import { Field, S, T } from './ui';

// ── Ripoti binafsi ya staff kwa wiki ────────────────────────────────────
// Moja kwa staff kwa wiki. Admin anaona za wote; staff anaona zake
// pamoja na za wenzake (ili wajifunze kutoka kwa kila mmoja).

export default function StaffWeekly() {
  const { currentUser, userRole } = useAuth();
  const navigate = useNavigate();

  const [anchor, setAnchor] = useState(new Date());
  const [values, setValues] = useState({});
  const [programIds, setProgramIds] = useState([]);
  const [existing, setExisting] = useState(null);
  const [others, setOthers] = useState([]);
  const [tab, setTab] = useState('mine');
  const [openId, setOpenId] = useState(null);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');

  const wk = isoWeekKey(anchor);
  const isCurrent = wk === isoWeekKey();

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [wk]);

  async function load() {
    try {
      const mine = await fetchReportById(staffWeeklyId(currentUser.uid, wk));
      if (mine) {
        setExisting(mine);
        setValues(mine.values || {});
        setProgramIds(mine.programIds || []);
      } else {
        setExisting(null); setValues({}); setProgramIds([]);
      }
      const all = await fetchReports({ kind: 'staffWeekly', weekKey: wk });
      setOthers(all.filter(r => r.authorId !== currentUser.uid));
    } catch (e) { console.error(e); }
  }

  function change(k, v) { setValues(p => ({ ...p, [k]: v })); }

  function toggleProgram(id) {
    setProgramIds(list => list.includes(id) ? list.filter(x => x !== id) : [...list, id]);
  }

  async function submit() {
    const missing = STAFF_WEEKLY_FIELDS.filter(f => f.required && !values[f.key]);
    if (missing.length) {
      setErr(`Bado hujajaza: ${missing.map(f => f.label).join(', ')}`);
      window.scrollTo(0, 0);
      return;
    }
    setSaving(true); setErr('');
    try {
      const name = await resolveAuthorName(currentUser);
      await saveStaffWeekly({
        weekKey: wk,
        weekLabel: weekLabel(anchor),
        values, programIds,
        author: { uid: currentUser.uid, name },
      });
      setMsg('Ripoti yako ya wiki imehifadhiwa.');
      load();
      setTimeout(() => setMsg(''), 3000);
    } catch (e) { console.error(e); setErr('Imeshindikana kuhifadhi.'); }
    setSaving(false);
  }

  const pct = completionOf(values, STAFF_WEEKLY_FIELDS);

  return (
    <div style={S.layout}>
      <Sidebar />
      <div style={S.main}>

        <div style={{ marginBottom: '16px' }}>
          <div onClick={() => navigate('/programs')} style={{ fontSize: '12px', color: T.muted, cursor: 'pointer', marginBottom: '7px' }}>
            ← Programu
          </div>
          <h1 style={S.h1}>Ripoti Yangu ya Wiki</h1>
          <p style={{ ...S.sub, marginTop: '6px' }}>
            Wiki yako ilikuwaje — changamoto, mafanikio, ulichokiona field na mipango ya wiki ijayo.
          </p>
        </div>

        {/* Kiongozi cha wiki */}
        <div style={S.card}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
            <button style={{ ...S.btnGhost, padding: '8px 13px' }} onClick={() => setAnchor(shiftWeeks(anchor, -1))}>‹</button>
            <div style={{ textAlign: 'center', flex: 1 }}>
              <div style={{ fontSize: '13.5px', fontWeight: 800, color: T.green }}>{weekLabel(anchor)}</div>
              <div style={{ fontSize: '11px', color: T.muted, marginTop: '3px' }}>
                {isCurrent ? `siku ${daysLeftInWeek()} zimebaki` : wk}
              </div>
            </div>
            <button style={{ ...S.btnGhost, padding: '8px 13px', opacity: isCurrent ? 0.35 : 1 }}
              disabled={isCurrent} onClick={() => setAnchor(shiftWeeks(anchor, 1))}>›</button>
          </div>
        </div>

        <div style={{ display: 'flex', gap: '7px', marginBottom: '14px' }}>
          {[
            { k: 'mine', l: 'Yangu' },
            { k: 'team', l: `Za wenzangu (${others.length})` },
          ].map(t => (
            <button key={t.k} onClick={() => setTab(t.k)}
              style={{
                padding: '9px 16px', borderRadius: '99px', cursor: 'pointer',
                border: `1px solid ${tab === t.k ? T.green : T.line}`,
                background: tab === t.k ? T.green : '#fff',
                color: tab === t.k ? '#fff' : T.muted,
                fontSize: '12.5px', fontWeight: 700, fontFamily: 'inherit',
              }}>{t.l}</button>
          ))}
        </div>

        {msg && <div style={S.ok}>{msg}</div>}
        {err && <div style={S.err}>{err}</div>}

        {tab === 'mine' ? (
          <>
            {existing && (
              <div style={{ ...S.card, background: '#ECFDF5', border: '1px solid #A7F3D0', fontSize: '12.5px', color: '#065F46', lineHeight: 1.6 }}>
                <Icon name="check" size={14} color="#059669" /> Ulishaandika ripoti ya wiki hii {fmtDateTime(existing.createdAt)}.
                Unaweza kuiboresha hapa chini.
              </div>
            )}

            <div style={S.card}>
              <label style={S.label}>Ulifanya kazi kwenye programu zipi wiki hii?</label>
              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                {PROGRAMS.map(p => {
                  const on = programIds.includes(p.id);
                  return (
                    <button key={p.id} onClick={() => toggleProgram(p.id)}
                      style={{
                        padding: '9px 15px', borderRadius: '99px', cursor: 'pointer',
                        border: `1px solid ${on ? p.color : T.line}`,
                        background: on ? p.color : '#fff',
                        color: on ? '#fff' : T.muted,
                        fontSize: '12px', fontWeight: 700, fontFamily: 'inherit',
                      }}>{p.short}</button>
                  );
                })}
              </div>
            </div>

            <div style={{ ...S.card, padding: '14px 18px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12.5px', marginBottom: '9px' }}>
                <span style={{ color: T.muted, fontWeight: 600 }}>Ukamilifu</span>
                <strong style={{ color: pct === 100 ? '#059669' : T.green }}>{pct}%</strong>
              </div>
              <div style={{ height: '7px', background: '#F0EEE7', borderRadius: '99px', overflow: 'hidden' }}>
                <div style={{ width: `${pct}%`, height: '100%', background: pct === 100 ? '#059669' : T.green }} />
              </div>
            </div>

            <div style={S.card}>
              {STAFF_WEEKLY_FIELDS.map(f => (
                <Field key={f.key} field={f} value={values[f.key]} onChange={change} color={T.green} />
              ))}
            </div>

            <button style={{ ...S.btn, width: '100%', marginBottom: '30px', opacity: saving ? 0.6 : 1 }}
              disabled={saving} onClick={submit}>
              {saving ? 'Inahifadhi...' : existing ? 'Hifadhi mabadiliko' : 'Hifadhi ripoti yangu'}
            </button>
          </>
        ) : (
          others.length === 0 ? (
            <div style={{ ...S.card, ...S.empty }}>
              Hakuna staff mwingine aliyeandika ripoti ya wiki hii bado.
            </div>
          ) : others.map(r => {
            const isOpen = openId === r.id;
            return (
              <div key={r.id} style={{ ...S.card, padding: 0, overflow: 'hidden' }}>
                <div onClick={() => setOpenId(isOpen ? null : r.id)}
                  style={{ padding: '15px 18px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '11px' }}>
                  <div style={{
                    width: '34px', height: '34px', borderRadius: '10px', flexShrink: 0,
                    background: '#4527A015', display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}>
                    <Icon name="user" size={15} color="#4527A0" />
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: '13.5px', fontWeight: 700, color: T.ink }}>{r.authorName}</div>
                    <div style={{ fontSize: '11px', color: T.muted, marginTop: '2px' }}>
                      {(r.programIds || []).map(id => PROGRAMS.find(p => p.id === id)?.short).filter(Boolean).join(', ') || '—'}
                    </div>
                  </div>
                  <span style={{ color: T.muted, transform: isOpen ? 'rotate(90deg)' : 'none' }}>›</span>
                </div>
                {isOpen && (
                  <div style={{ padding: '0 18px 18px', borderTop: `1px solid ${T.line}` }}>
                    <div style={{ paddingTop: '14px' }}>
                      {STAFF_WEEKLY_FIELDS.filter(f => r.values?.[f.key]).map(f => (
                        <div key={f.key} style={{ marginBottom: '13px' }}>
                          <div style={{ fontSize: '11.5px', color: T.muted, fontWeight: 700 }}>{f.label}</div>
                          <div style={{ fontSize: '13.5px', color: T.ink, marginTop: '3px', lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>
                            {r.values[f.key]}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            );
          })
        )}

        {userRole === 'admin' && tab === 'team' && (
          <div style={{ ...S.card, background: '#FAF8F3', fontSize: '12px', color: T.muted, lineHeight: 1.7 }}>
            <Icon name="info" size={12} color={T.orange} /> Kama admin, unaziona ripoti za staff wote
            wa wiki husika. Tumia mishale ya wiki hapo juu kurudi nyuma.
          </div>
        )}

      </div>
    </div>
  );
}
